import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadPermissions, updatePermission } from './actions';
import ActionList from './ActionList';
import PageList from './PageList';
import EditPermission from './EditPermission';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import authUtils from '../../auth/utils';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

class Permissions extends Component {
	constructor(props) {
		super(props);
		this.hideDialog = this.hideDialog.bind(this);
		this.showDialog = this.showDialog.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.state = { showDialog: false };
	}

	componentDidMount() {		
		const objectId = this.props.objectId;
		const objectType = this.props.objectType;
		this.props.loadData({ objectId, objectType });
	}

	handleListEvent() {
		const objectId = this.props.objectId;
		const objectType = this.props.objectType;
		this.props.loadData({ objectId, objectType });
	}

	hideDialog() {
		this.setState({ showDialog: false });
	}

	showDialog(permission) {
		this.setState({ showDialog: true, permission });
	}

	handleSave(values) {
		const { permission } = this.state;

		if (permission) {
			this.props.updatePermission(permission.id, values);
		} 

		this.hideDialog();
	}

	renderDialogFooter() {
		const t = this.props.t;
		const closeBtn = <Button onClick={this.hideDialog}>{t('Common_Close')}</Button>;
		const saveBtn = <RemoteSubmitButton style='success' formName='editPermission' label={t('Common_Save')} icon={faCheck} />;
		return [closeBtn, saveBtn];
	}

	dialogConfig() {
		const { t, permissionsType, ...rest } = this.props;
		const { permission } = this.state;

		return {
			header: t('Permission_EditPermission'),
			body: <EditPermission onSubmit={this.handleSave} initialValues={permission} permissionsType={permissionsType} {...rest} />,
			onHide: () => this.hideDialog(),
			footer: this.renderDialogFooter()
		};
	}

	render() {
		const { actionPermissions, pagePermissions, objectId, objectType, objectName, permissionsType, t, isReadonly } = this.props;		

		const dialogConfig = this.dialogConfig();
		const backPath = (objectType === 'role') ? '/roles' : '/users';

		return (
			<div className='mb-1'>
				<Dialog config={dialogConfig} show={this.state.showDialog} />
				<ActionList isReadonly={isReadonly} objectId={objectId} objectType={objectType} onFetchData={this.handleListEvent} data={actionPermissions} objectName={objectName} onClick={this.showDialog} />
				<PageList isReadonly={isReadonly} objectId={objectId} objectType={objectType} onFetchData={this.handleListEvent} data={pagePermissions} objectName={objectName} permissionsType={permissionsType} onClick={this.showDialog} />
				<Link to={backPath} className='btn btn-default'>{t('Common_BackToList')}</Link>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const objectId = ownProps.match.params.objectId;
	const objectType = ownProps.match.params.objectType;
	const objectName = ownProps.match.params.objectName;

	const {		
		entities: { permissions },
		lookups: { userPermissions, rolePermissions },
		auth: { currentUser }
	} = state;

	let permissionsType = (objectType == "role") ? rolePermissions : userPermissions;

	let allPermissions = Object.values(permissions);
	let actionPermissions = allPermissions.filter((permission) => permission.type.name == 'Action' && permission.objectId == objectId && permission.objectType == objectType);
	let pagePermissions = allPermissions.filter((permission) => permission.type.name == 'Page' && permission.objectId == objectId && permission.objectType == objectType);

	return {
		actionPermissions: actionPermissions,
		pagePermissions: pagePermissions,
		objectId: objectId,
		objectType: objectType,
		objectName: objectName,
		permissionsType: permissionsType,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'SecuritySettings'),
	};
};

Permissions.propTypes = {
	objectId: PropTypes.string.isRequired,
	objectType: PropTypes.string.isRequired,
	objectName: PropTypes.string.isRequired
};

export default connect(mapStateToProps, {
	loadData: loadPermissions,
	updatePermission: updatePermission
})(withTranslation()(Permissions));